import { render } from "./ValidarCuenta.vue?vue&type=template&id=564e3ab0&scoped=true"
import script from "./ValidarCuenta.vue?vue&type=script&lang=js"
export * from "./ValidarCuenta.vue?vue&type=script&lang=js"

import "./ValidarCuenta.vue?vue&type=style&index=0&id=564e3ab0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564e3ab0"]])

export default __exports__